export default __webpack_public_path__ + "static/media/1.80a4b3c4.jpg";